import React from 'react';
import { Button, IconWrapper, StatusDot } from './CustomButton.styled';

const CustomButton = ({ icon: Icon, text, showStatusDot }) => {
  return (
    <Button>
      {showStatusDot && <StatusDot data-testid="status-dot" />}
      <IconWrapper>
        {Icon && <Icon />}
      </IconWrapper>
      {text}
    </Button>
  );
};

export default CustomButton;
